module.exports = __webpack_public_path__ + "static/media/wn.e96586ca.svg";